import React from 'react';
import { Controller } from 'react-hook-form';

import { ExtendedCheckbox, IExtendedCheckboxProps } from '../../components';
import { FormError } from '../FormError';
import { FormField } from '../FormField';

export interface IExtendedCheckboxFieldProps extends IExtendedCheckboxProps {
    name: string;
}

export const ExtendedCheckboxField: React.FC<IExtendedCheckboxFieldProps> = ({ name, ...inputProps }) => {
    return (
        <Controller
            name={name}
            render={({ field: { onChange, value, ...fieldProps }, fieldState: { error } }) => (
                <FormField errorSlot={error && <FormError>{error?.message}</FormError>}>
                    <ExtendedCheckbox
                        error={!!error}
                        onCheckedChange={(value) => {
                            onChange(value);
                        }}
                        checked={value}
                        {...fieldProps}
                        {...inputProps}
                    />
                </FormField>
            )}
        />
    );
};
